
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/lands/[color]/[slug]",
      function () {
        return require("private-next-pages/lands/[color]/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/lands/[color]/[slug]"])
      });
    }
  